import React from 'react';
import { useRolesSelectors } from 'src/@app/reducers';

// tslint:disable:react-hooks-nesting - done because you can use hooks in HOCs
export const withPermissionsCheck = (
  Component: any,
  readPermission: string,
  updatePermission: string
) => ({ ...props }) => {
  const rolesSelector = useRolesSelectors();
  const canView = rolesSelector.hasPermission(readPermission);
  const canUpdate = rolesSelector.hasPermission(updatePermission);

  if (canView) {
    return <Component {...props} readOnly={!canUpdate} canSave={canUpdate} />;
  }

  return null;
};
